import { render, staticRenderFns } from "./EipPaginationLayout.vue?vue&type=template&id=0a65fa9a&"
import script from "./EipPaginationLayout.vue?vue&type=script&lang=js&"
export * from "./EipPaginationLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports